import React from "react";
import ReactDOM from "react-dom";
import "./Poppins-Regular.ttf";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
